<template>
  <div v-if="disabled">{{ lang.get('entries.form.preview') }}</div>
  <a v-else :href="route" class="btn btn-tertiary btn-lg">
    {{ lang.get('entries.form.preview') }}
  </a>
</template>

<script>
import { mapState } from 'vuex';
export default {
  inject: ['lang'],
  computed: {
    disabled() {
      return this.configurationMode || this.uploadInProgress;
    },
    ...mapState('entryForm', ['entry', 'uploadInProgress']),
    route() {
      return `/entry/entrant/${this.entry.slug}/preview`;
    },
    ...mapState('entryFormConfiguration', ['configurationMode'])
  }
};
</script>
